import { useMemo } from 'react';
import { useData } from '../store/data';
import { speak as rawSpeak, playSound, stopAll, type SpeakOptions } from '../lib/audio';

export function useAudio() {
  const { config } = useData();
  return useMemo(
    () => ({
      speak: (text: string, overrides?: SpeakOptions) =>
        rawSpeak(text, {
          lang: config.tts_lang,
          rate: config.tts_rate,
          pitch: config.tts_pitch,
          voiceURI: config.tts_voice,
          ...overrides
        }),
      play: playSound,
      stop: stopAll
    }),
    [config]
  );
}
